/**
 * Main-shell tab ids and scene keys (no Phaser — safe for unit tests).
 */

export type ShellTab = 'hero' | 'talents' | 'town' | 'quests' | 'settings';

export const SHELL_TAB_SCENES: Record<ShellTab, string> = {
  hero: 'Hero',
  talents: 'Talents',
  town: 'Village',
  quests: 'Quests',
  settings: 'Settings',
};
